const slugs = [
  'dezwerver',
  'bagageonline',
  'my-jewellery',
  'bulbby',
  'hellofresh',
  'andc',
  'grazia',
  'hellofresh-be',
  'flair-be',
  'cadeautje',
  'feeling',
]

interface IRedirect {
  path: string
  urls: { [key: string]: string | null }
}

const redirects: IRedirect[] = []
slugs.forEach(slug => {
  redirects.push({
    path: '/' + slug,
    urls: {
      default: `/discount/${slug}`,
      nl: `/korting/${slug}`,
      be: `/korting/${slug}`,
    },
  })
})

export { redirects }
